export enum INTEGRATED_LOAD_DETAIL_VIEW_TAB {
  Load = 'load',
  Shipments = 'shipments',
  Freight = 'items',
  Docs = 'docs',
  AuditTrail = 'audit-trail',
  Exceptions = 'exceptions',
  Notes = 'notes',
}

export enum INTEGRATED_LOAD_AUDIT_TRAIL_EVENT_TYPE {
  Admin = 'Admin',
  Customs = 'Customs',
  Delivery = 'Delivery',
  Exception = 'Exceptions',
  InTransit = 'In-Transit',
  Pickup = 'Pickup',
  Tender = 'Tender',
}

export const FREIGHT_TOTALS_RECORD_ID = 0
